<style lang="scss" scoped>
.image-wrapper {
    padding-top: percentage(510 / 363);
    @apply relative rounded-sm overflow-hidden;

    img {
        @apply absolute inset-0 w-full h-full object-cover object-center;
    }
}

.coverup {
    @apply bg-white relative h-full;
    z-index: 3;

    &:before {
        content: "";
        @apply absolute top-0 right-0 h-full w-screen bg-white;
    }
}

.green-wrapper {
    @apply bg-green md:pr-40 md:absolute md:top-0;

    > div > * {
        position: relative;
        z-index: 10;
    }

    &:before {
        content: "";
        right: 0;
        top: 0;
        z-index: -1;
        width: 100%;
        height: 100%;

        @apply absolute  bg-green rounded-sm;

        @media screen and (min-width: 1024px) {
        }

        @media screen and (min-width: 1136px) {
            right: -192px;
            top: -120px;

            width: calc(100% + (2 * 192px));
            height: calc(100% + (2 * 120px));
        }
    }

    &:after {
        content: "";
        right: -24px;
        bottom: -40px;
        z-index: 5;
        width: calc(100% + 192px);
        height: calc(100% + (2 * 40px));
        border-radius: 4px 0 0 4px;

        @apply absolute  bg-green;

        @media screen and (min-width: 768px) {
            bottom: -80px;
            height: calc(100% + (2 * 80px));
        }

        @media screen and (min-width: 1024px) {
            right: 0;

        }

        @media screen and (min-width: 1136px) {
            bottom: -120px;
            right: 0;

            width: calc(100% + 192px);
            height: calc(100% + (2 * 120px));
        }
    }
}

.people-slider {
    z-index: 2;
}

.controls {
    bottom: calc(100% + 24px);
    right: -4px;
    display: flex;
    position: absolute;
    z-index: 10;
    align-items: center;
    pointer-events: none;

    @media screen and (min-width: 768px) {
        bottom: calc(100% + 48px);
    }

    &:focus,
    &:active {
        outline: none;
    }

    .left,
    .right {
        opacity: 1;
        transition: opacity 0.2s, left 0.2s, width 0.2s, right 0.2s, transform 0.2s;
        width: 36px;
        height: 16px;
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 38px 44px;
        pointer-events: all;
        background-image: url("/svg/arrow-right.svg");
        background-position: center;
        margin: 0 4px;

        &:focus,
        &:active {
            outline: none;
        }

        &[aria-disabled="true"] {
            opacity: 0.3;
        }
    }

    .left {
        @apply transform rotate-180;
    }
}

::v-deep .tns-ovh {
    overflow: visible;
}
</style>

<template>
    <section v-if="slides && slides.length > 0" class="md:pt-120">
        <div class="md:gap-y-32 gap-y-80 md:grid relative flex flex-col flex-wrap grid-cols-12">
            <div class="md:py-0 lg:col-span-4 relative col-span-5 py-40">
                <div class="coverup"></div>
                <div class="green-wrapper relative">
                    <div class="relative">
                        <h2 v-if="title !== ''" class="text-h3 lg:text-h2 font-mon mb-8 font-bold text-white" :class="{ 'mb-8': description !== '', 'mb-24': description === '' }" v-html="title"></h2>
                        <div v-if="description !== ''" class="font-mon mb-40 text-white" v-html="description"></div>
                        <slot></slot>
                    </div>
                </div>
            </div>
            <div class="lg:col-span-8 relative col-span-6 col-end-13">
                <div ref="slider" class="people-slider">
                    <div class="flex flex-col" v-for="(slide, index) in slides" :key="index">
                        <div class="image-wrapper mb-16">
                            <img :src="slide.image" :alt="slide.image.alt" />
                        </div>
                        <p class="md:text-32 text-h5 mb-8 font-bold" v-html="slide.name"></p>
                        <p class="text-tiny text-green font-bold uppercase" v-html="slide.subtitle"></p>
                    </div>
                </div>
                <div ref="customcontrols" class="controls">
                    <div ref="prev" class="left"></div>
                    <div ref="next" class="right"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider";

export default {
    props: {
        title: {
            default: "",
            required: false
        },
        description: {
            default: "",
            required: false
        },
        slides: {
            type: Array,
            required: true
        }
    },

    data: () => ({
        slider: null
    }),

    mounted() {
        this.initSlider();
    },

    methods: {
        initSlider() {
            this.$nextTick(() => {
                this.slider = tns({
                    container: this.$refs.slider,
                    items: 2,
                    preventScrollOnTouch: "force",
                    mouseDrag: true,
                    loop: false,
                    gutter: 24,
                    controls: true,
                    nav: false,
                    swipeAngle: false,
                    controlsContainer: this.$refs.customcontrols
                });
            });
        }
    }
};
</script>
